import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

/**
 * Shared layout for 404 / 500 / network error screens.
 */
export default function ErrorPageLayout({
  code,
  title,
  description,
  icon: Icon,
  variant = 'default',
  primaryLabel = 'Go to home',
  onPrimary,
  secondaryLabel,
  onSecondary,
  className,
}) {
  const isDestructive = variant === 'destructive';

  return (
    <div
      className={cn(
        'flex min-h-screen flex-col items-center justify-center bg-background px-4 py-12 text-center',
        className
      )}
    >
      <div
        className={cn(
          'mb-6 flex h-16 w-16 items-center justify-center rounded-2xl',
          isDestructive ? 'bg-destructive/10 text-destructive' : 'bg-primary/10 text-primary'
        )}
      >
        {Icon ? <Icon className="h-8 w-8" /> : null}
      </div>

      {code && (
        <p
          className={cn(
            'text-6xl font-bold tracking-tight sm:text-7xl',
            isDestructive ? 'text-destructive' : 'text-primary'
          )}
        >
          {code}
        </p>
      )}

      <h1 className="mt-2 text-2xl font-bold text-foreground sm:text-3xl">{title}</h1>
      <p className="mt-3 max-w-md text-base text-muted-foreground">{description}</p>

      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        {onPrimary && (
          <Button size="lg" className="eh-touch-target min-w-[140px]" onClick={onPrimary}>
            {primaryLabel}
          </Button>
        )}
        {onSecondary && secondaryLabel && (
          <Button size="lg" variant="outline" className="eh-touch-target" onClick={onSecondary}>
            {secondaryLabel}
          </Button>
        )}
      </div>
    </div>
  );
}
